module.exports = __webpack_public_path__ + "images/7a97b885bd9d48f39d2f46630eb5914aTraffic.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Traffic.png
// module id = PmpW
// module chunks = 0